import {AxiosError} from 'axios'

import {API} from '../../networking/http'
import {QueryMethod, QueryOptions, UseQueryOptions} from '../helpers/types'

export type GetUserDataByEmailParams = undefined
export type GetUserDataByEmailQueryParams = {
  email?: string
}
export type GetUserDataByEmailQueryReturnType = {
  venueNames?: string[]
  user?: {
    name: string
    avatar: string | null
  }
} | null
export type GetUserDataByEmailQuery = QueryMethod<
  GetUserDataByEmailParams,
  GetUserDataByEmailQueryParams,
  GetUserDataByEmailQueryReturnType
>

type Par = QueryOptions<
  GetUserDataByEmailParams,
  GetUserDataByEmailQueryParams,
  GetUserDataByEmailQueryReturnType
>

type QueOp = UseQueryOptions<GetUserDataByEmailQueryReturnType, AxiosError, GetUserDataByEmailQueryReturnType, [string, GetUserDataByEmailQueryParams | undefined]>

export const makeGetUserDataByEmailEndpoint = 'user/data/byPhoneEmail'

export const getUserDataByEmailQuery = ({query}: Par): QueOp => ({
  queryKey: ['getUserDataByEmailQuery', query],
  cacheTime: 1000 * 60 * 60,
  refetchOnWindowFocus: false,
  queryFn: ({queryKey: [_, config]}) => {
    if (!query?.email) {
      return Promise.resolve(null)
    }
    return API.get<GetUserDataByEmailQueryParams, GetUserDataByEmailQueryReturnType>(makeGetUserDataByEmailEndpoint, {
      params: config,
    }).then((res) => {
      return res.data
    }).catch(() => {
      return null
    })
  },
})
